import React from 'react'

import { StyledImage, StyledImageProps } from 'component-library/content/Picture/Image.web'
import { safeAttr } from 'component-library/content/Picture/utils'

type Props = Exclude<StyledImageProps & React.HTMLProps<HTMLImageElement>, 'show'>

const NoScriptImage: React.FC<Props> = props => {
    const alt = props.alt ? ` alt="${safeAttr(props.alt)}"` : ''
    const src = props.src ? `src="${encodeURI(props.src)}"` : ''
    const srcset = props.srcSet ? ` srcset="${encodeURI(props.srcSet)}"` : ''

    const imgMarkup = `<img ${src} ${alt} ${srcset} class="${props.className}" />`

    return <noscript dangerouslySetInnerHTML={{ __html: imgMarkup }} />
}

NoScriptImage.displayName = 'NoScriptImage'

export const StyledNoScriptImage = StyledImage.withComponent(NoScriptImage)
StyledNoScriptImage.displayName = 'StyledNoScriptImage'
